// extracted by mini-css-extract-plugin
export default {"wrapper":"FavoriteIcon__wrapper--127","actuator":"FavoriteIcon__actuator--1ml","icon":"FavoriteIcon__icon--9mi","featured":"FavoriteIcon__featured--2P2","on":"FavoriteIcon__on--1hB"};